import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { NeWordSvg } from './NeWordSvg'

export const NeWordIcon = (props: PropsWithoutRef<IconBaseProps>) => {
  return <Icon component={NeWordSvg} {...props} />
}
